import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/AutoAcceptance/messages';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

type RejectSuggestionPayload = {
  resultId: number;
  rejectionReason: string;
};

const rejectSuggestion = async ({
  resultId,
  rejectionReason,
}: RejectSuggestionPayload) => {
  const body = {
    auto_acceptance_result: {
      propagate_to_application: true,
      rejection_reason: rejectionReason,
    },
  };
  const { data } = await putRequest(API.PUT.rejectSuggestion(resultId), body);
  return data;
};

export const useRejectSuggestion = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: rejectSuggestion,
    onSuccess: () => {
      // client.invalidateQueries({
      //   queryKey: [QUERY_KEYS.AUTO_ACCEPTANCE_RESULTS],
      // });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CALENDAR_JOBS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOBS],
      });
      handleSuccess(formatMessage(messages.suggestionRejected));
    },
    onError: handleError,
  });
};
